import ContentCard from "../../ui/ContentCard";
import ContentCardTitle from "../../ui/ContentCardTitle";
import { useDispatch, useSelector } from "react-redux";
import { Skeleton } from "antd";
import styles from "../../styles/Components/exchange-portfolio/ConnectedExchanges.module.css";
import ConnectToExchangeButton from "../../shared/connect-to-exchange/ConnectToExchangeButton";
import { openExchangeConnectionSettings } from "../../redux/exchange/actions";
import React, { useRef, useState } from "react";
import UpdateExchangeIpModal from "../../shared/exchange-ip-setting/UpdateExchangeIpModal";
import ExchangeConnectionSettingsMenu from "../../shared/connect-to-exchange/ExchangeConnectionSettingsMenu";
import { LazyLoadImage } from "react-lazy-load-image-component";

function ConnectedExchanges() {
  const {
    exchangeState: {
      integratedData,
      integratedDataLoading,
      integratedDataError,
    },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  const [showIpSettingsModal, setShowIpSettingsModal] = useState(false);
  const selectedExchange = useRef(null);

  const topExchanges = integratedData?.filter(
    (ex) => ex?.id !== "cryptocrispy",
  );
  // ?.slice(0, 2);
  const demoExchange = integratedData?.filter(
    (ex) => ex?.id === "cryptocrispy",
  );

  const changeSetting = (exchange) => () => {
    if (exchange?.ip_status !== "OK") {
      selectedExchange.current = exchange;
      return setShowIpSettingsModal(true);
    } else {
      return dispatch(openExchangeConnectionSettings(exchange?.id));
    }
  };

  return (
    <ContentCard style={{ margin: "1.5rem 0" }}>
      <div className={styles.header}>
        <ContentCardTitle title="Connected Exchanges" />
        <ConnectToExchangeButton />
      </div>
      <ul className={styles.exchangeList}>
        {integratedDataLoading &&
          Array.from({ length: 4 })?.map((_, i) => (
            <li key={i}>
              <Skeleton.Node active className={styles.skeleton} />
            </li>
          ))}
        {!integratedDataLoading && !integratedDataError && demoExchange && (
          <li className={`${styles.exchangeItem}`} style={{ cursor: "unset" }}>
            <LazyLoadImage
              src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/crypto_exchanges_logo/cryptocrispy.svg`}
              alt="DemoExchange Logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/placeholders/exchange-logo.svg";
              }}
              width="20px"
              height="20px"
              effect="blur"
              style={{ borderRadius: "100%" }}
            />
            Demo Exchange
          </li>
        )}
        {!integratedDataLoading &&
          !integratedDataError &&
          topExchanges?.map((ex) => (
            <li
              key={ex.id}
              className={`${styles.exchangeItem}`}
              onClick={changeSetting(ex)}
            >
              <LazyLoadImage
                src={`https://cryptocrispypro.s3.ap-southeast-2.amazonaws.com/crypto_exchanges_logo/${ex?.id}.svg`}
                alt={ex?.name}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/placeholders/exchange-logo.svg";
                }}
                width="20px"
                height="20px"
                effect="blur"
                style={{ borderRadius: "100%" }}
              />
              {ex?.name}
              {ex?.status !== "Active" ? (
                <span className={styles.statusBadge}>{ex?.status}</span>
              ) : ex?.ip_status !== "OK" ? (
                <span className={styles.statusBadge}>IP Update</span>
              ) : (
                ""
              )}
            </li>
          ))}
        {/*{!integratedDataLoading &&*/}
        {/*  !integratedDataError &&*/}
        {/*  integratedData?.length > 3 && (*/}
        {/*    <li className={`${styles.exchangeItem}`}>More</li>*/}
        {/*  )}*/}
      </ul>

      <UpdateExchangeIpModal
        show={showIpSettingsModal}
        setShow={setShowIpSettingsModal}
        exchangeData={selectedExchange}
      />
      <ExchangeConnectionSettingsMenu />
    </ContentCard>
  );
}

export default ConnectedExchanges;
